export default __webpack_public_path__ + "static/media/l22-white.1b3d6571.svg";